import React from "react";
import { Card, CardContent } from "./ui/card";
import { Video, Globe, Star, Target, Users, Award } from "lucide-react";

const AboutSection = () => {
  const missionPoints = [
    {
      icon: Video,
      title: "Produksi Audio-Visual Terbaik",
      description: "Menciptakan konten visual berkualitas tinggi dengan teknologi terdepan dan tim kreatif berpengalaman."
    },
    {
      icon: Globe,
      title: "Membentuk Citra Positif dengan Teknologi Modern",
      description: "Membangun brand identity yang kuat melalui pendekatan teknologi inovatif dan strategi digital terpadu."
    },
    {
      icon: Star,
      title: "Meningkatkan Kualitas Layanan",
      description: "Berkomitmen memberikan solusi multimedia terbaik dengan standar internasional dan kepuasan klien."
    }
  ];

  const stats = [
    { icon: Target, number: "500+", label: "Project Completed" },
    { icon: Users, number: "50+", label: "Happy Clients" },
    { icon: Award, number: "8+", label: "Years Experience" }
  ];

  return (
    <section id="about" className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <span className="inline-block px-4 py-2 bg-blue-100 text-blue-700 rounded-full text-sm font-semibold mb-4">
              Tentang Kami
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Tentang <span className="text-gradient-blue-orange">RanselPro</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              PT Multimedia Ransel Pro adalah perusahaan kreatif yang berdedikasi untuk memberikan solusi multimedia terbaik, 
              memadukan kreativitas dan teknologi untuk menciptakan hasil yang luar biasa.
            </p>
          </div>

          {/* Vision & Mission Cards */}
          <div className="grid md:grid-cols-3 gap-8 mb-16">
            {missionPoints.map((point, index) => (
              <Card key={index} className="card-hover border-0 bg-white shadow-lg">
                <CardContent className="p-8 text-center">
                  <div className="w-16 h-16 mx-auto mb-6 bg-gradient-to-br from-blue-500 to-orange-500 rounded-2xl flex items-center justify-center">
                    <point.icon className="w-8 h-8 text-white" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4">{point.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{point.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>

          {/* Company Stats */}
          <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12">
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div>
                <h3 className="text-3xl font-bold text-gray-900 mb-6">
                  Mengapa Memilih RanselPro?
                </h3>
                <div className="space-y-4">
                  <div className="flex items-start space-x-3">
                    <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mt-1">
                      <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-1">Tim Profesional Berpengalaman</h4>
                      <p className="text-gray-600">Didukung oleh tim kreatif dan teknis dengan pengalaman bertahun-tahun</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <div className="w-6 h-6 bg-orange-100 rounded-full flex items-center justify-center mt-1">
                      <div className="w-3 h-3 bg-orange-500 rounded-full"></div>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-1">Teknologi Terdepan</h4>
                      <p className="text-gray-600">Menggunakan peralatan dan software terbaru untuk hasil optimal</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mt-1">
                      <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-1">Layanan Komprehensif</h4>
                      <p className="text-gray-600">One-stop solution untuk semua kebutuhan multimedia dan digital</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-3 gap-6">
                {stats.map((stat, index) => (
                  <div key={index} className="text-center">
                    <div className="w-12 h-12 mx-auto mb-3 bg-gradient-to-br from-blue-100 to-orange-100 rounded-xl flex items-center justify-center">
                      <stat.icon className="w-6 h-6 text-blue-600" />
                    </div>
                    <div className="text-2xl font-bold text-gray-900 mb-1">{stat.number}</div>
                    <div className="text-sm text-gray-600">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;